import React from "react"
import BeehiivSubscribeEmbed from "./beehiiv-subscribe-embed"

const SiteFooter = ({ showNewsletter = true }) => (
  <footer className="site-footer fade-footer">
    {showNewsletter ? (
      <div className="newsletter-strip footer-newsletter">
        <div className="nl-label">
          get the digest
          <span>one email every week</span>
        </div>
        <BeehiivSubscribeEmbed className="nl-form nl-form--embed" />
      </div>
    ) : null}

    <div className="footer-bar">
      <div className="footer-left">catwomaniya.xyz</div>
      <div className="footer-links">
        <a
          className="footer-link"
          href="https://x.com/dalekno99"
          target="_blank"
          rel="noreferrer"
        >
          x
        </a>
        <a
          className="footer-link"
          href="https://catwomaniya.beehiiv.com"
          target="_blank"
          rel="noreferrer"
        >
          beehiiv
        </a>
      </div>
    </div>
  </footer>
)

export default SiteFooter
